import { render, staticRenderFns } from "./CatalogCategoryFilters.vue?vue&type=template&id=9fb6d26e&scoped=true"
import script from "./CatalogCategoryFilters.vue?vue&type=script&lang=js"
export * from "./CatalogCategoryFilters.vue?vue&type=script&lang=js"
import style0 from "./CatalogCategoryFilters.vue?vue&type=style&index=0&id=9fb6d26e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb6d26e",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fcatalog-category-filters%2FCatalogCategoryFilters.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports